export default __webpack_public_path__ + "static/media/wh-cross.52d465f6.svg";